import dayjs from "dayjs";

  
export const convertDate = (date) => {
    const timestamp = parseInt(date.replace("/Date(", "").replace(")/", ""), 10);
    return dayjs(timestamp).format("DD-MM-YYYY HH:mm");
};

export const labelsAndValuesMapping = (labels, values, labelKey, valueKey) => {
    const result = [];
    for (let i = 0; i < labels.length; i++) {
      result.push({
        [labelKey]: labels[i],
        [valueKey]: values[i],
      });
    }

    return result;
}

export const labelsAndTwoValuesMapping = (labels, firstValues, secondValues, labelKey, firstValuesKey, secondValuesKey) => {
  const result = [];
  for (let i = 0; i < labels.length; i++) {
    result.push({
      [labelKey] : labels[i],
      [firstValuesKey] : firstValues[i],
      [secondValuesKey] : secondValues[i],
    });
  }
  

  return result;
}
